import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const headscale = defineConnector({
  identifier: "headscale",
  name: "Headscale",
  tagLine: "Self-hosted Tailscale control server",
  logo,
  protocol: "http",
  tags: ["it"],
  defaultUrlPattern: ({ instanceUrl }) => domainToRegex(instanceUrl),
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Enter your Headscale server URL",
      items: [
        {
          kind: "url",
          label: "Server URL",
          required: true,
          placeholder: "https://headscale.example.com",
          target: { kind: "configuration", field: "instanceUrl" },
          helperText: "The base URL of your Headscale server.",
        },
      ],
    },
    {
      title: "Create an API key",
      items: [
        {
          kind: "markdown",
          content:
            "Generate an API key using the Headscale CLI: `headscale apikeys create`",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ instanceUrl }) => `${instanceUrl}/api/v1/node`,
  },
});
